import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import reduxReset from 'redux-reset';
import signup, { rootSignupSaga as signupSaga } from './signup';
import workouts, { rootSaga as workoutsSaga } from './workouts';
import log, { rootSaga as logSaga } from './log';
import auth, { LOGOUT, rootSaga as authSaga } from './auth';
import landing, { rootSaga as landingSaga } from './landing';
import theme from './theme';
import journey from './journey';
import race, { rootSaga as raceSaga } from './race';
import events, { rootSaga as eventsSaga } from './events';
import feedback, { rootSaga as feedbackSaga } from './feedback';
import analytics from './analytics';
import hub from './hub';
import completed, { rootSaga as completedSaga } from './completed';
import treningHistory from './treningHistory';
import profile, { rootSaga as profileSaga } from './profile';
import preferences from './preferences';
import toasts, { rootSaga as toastsSaga } from './toasts';
import promiseMiddleware from '../utils/promiseMiddleware';
import { persistSaga } from '../utils/persist';

const sagaMiddleware = createSagaMiddleware();
const middleware = [promiseMiddleware, sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
    middleware.push(createLogger());
}

const createStoreWithMiddleware = compose(
    applyMiddleware(
      ...middleware,
    ),
    reduxReset(LOGOUT),
)(createStore);


export function* rootSaga() {
    yield [
        logSaga(),
        signupSaga(),
        persistSaga(),
        raceSaga(),
        profileSaga(),
        completedSaga(),
        toastsSaga(),
        authSaga(),
        eventsSaga(),
        workoutsSaga(),
        feedbackSaga(),
        landingSaga(),
    ];
}

const create = (...args) => {
    const store = createStoreWithMiddleware(
        combineReducers({
            analytics,
            auth,
            completed,
            events,
            feedback,
            hub,
            journey,
            landing,
            log,
            preferences,
            profile,
            race,
            treningHistory,
            theme,
            toasts,
            signup,
            workouts,
        }),
        ...args,
    );
    sagaMiddleware.run(rootSaga);
    return store;
};

export default create;



/** WEBPACK FOOTER **
 ** ./src/redux/index.js
 **/